import React from "react";
import Footer from "./footer";
import { useLanguage } from "../LanguageContext";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import brochureImg from "../assets/products/watermeter/brosurWaterMeter.jpg";
import { FileText, BookAlert } from "lucide-react";
import userManualPDF from "../assets/usermanual/usermanual_daswmeter.pdf";

const ProductWater = () => {
  const { language } = useLanguage();

  const text = {
    en: {
      title: "DAS Water Meter",
      subtitle:
        "Portable Digital Flowmeter with Automatic Valve for fresh water filling of ships controlled via Mobile App.",
      download: "Download the brochure",
      manual: "Download the User Manual",
      specTitle: "Specification",
      features: [
        { icon: require("../assets/products/watermeter/water-meter.png"), label: "Iron Flowmeter 2.5 Inch" },
        { icon: require("../assets/products/watermeter/water.png"), label: "Automatic Open/Close Motorized Valve 2.5 Inch" },
        { icon: require("../assets/products/watermeter/water-level.png"), label: "Use Sensor for Counting FlowMeter" },
        { icon: require("../assets/products/watermeter/battery.png"), label: "1x 3000mAh Backup Battery" },
      ],
      specs: [
        {
          title: "Network",
          desc: "LoRa Spread Spectrum, Freq 920-923 MHz",
        },
        {
          title: "Dimension (WxHxD)",
          desc: "489 x 511 x 479mm",
        },
        {
          title: "Power",
          desc: [
            "Main Battery: 24V Lifepo4 12Ah",
            "Backup Battery: 3.7V 3000mAh Lithium Battery",
          ],
        },
        {
          title: "Environmental Limits",
          desc: [
            "Operating Temperature: 10°C–70°C (50°F–158°F)",
            "Storage Temperature: 10°C–70°C (50°F–158°F)",
          ],
        },
        {
          title: "Interfaces",
          desc: [
            ["LCD & Keypad", "1x LCD Character & 1x Keypad Number"],
            ["Button", "Power Button, Emergency Button"],
            ["Flowmeter", "2.5 Inch Itron Flowmeter"],
            ["Valve", "2.5 Inch Iron Cast Butterfly Motorized Valve"],
            ["Flange", "1x Machino Male Output, 1x Machino Female Input"],
          ],
        },
      ],
      docsTitle: "Documentation",
      docs: [
        {
          title: "Port of Tanjung Priok",
          desc: "Installation of IDasWmeter",
          img: "wm1.jpg",
        },
        {
          title: "Port of Tanjung Priok",
          desc: "Installation of IDasWmeter",
          img: "wm2.jpg",
        },
      ],
    },
    id: {
      title: "DAS Water Meter",
      subtitle:
        "Flowmeter Digital Portabel dengan Katup Otomatis untuk pengisian air tawar kapal yang dikendalikan melalui Aplikasi Seluler.",
      download: "Unduh Brosur",
      manual: "Unduh Panduan Pengguna",
      specTitle: "Spesifikasi",
      features: [
        { icon: require("../assets/products/watermeter/water-meter.png"), label: "Flowmeter Besi 2.5 Inci" },
        { icon: require("../assets/products/watermeter/water.png"), label: "Katup Motor Otomatis Buka/Tutup 2.5 Inci" },
        { icon: require("../assets/products/watermeter/water-level.png"), label: "Sensor Penghitung Aliran Air" },
        { icon: require("../assets/products/watermeter/battery.png"), label: "1x Baterai Cadangan 3000mAh" },
      ],
      specs: [
        {
          title: "Network",
          desc: "LoRa Spread Spectrum, Freq 920-923 MHz",
        },
        {
          title: "Dimension (WxHxD)",
          desc: "489 x 511 x 479mm",
        },
        {
          title: "Power",
          desc: [
            "Main Battery: 24V Lifepo4 12Ah",
            "Backup Battery: 3.7V 3000mAh Lithium Battery",
          ],
        },
        {
          title: "Environmental Limits",
          desc: [
            "Operating Temperature: 10°C–70°C (50°F–158°F)",
            "Storage Temperature: 10°C–70°C (50°F–158°F)",
          ],
        },
        {
          title: "Interfaces",
          desc: [
            ["LCD & Keypad", "1x LCD Character & 1x Keypad Number"],
            ["Button", "Power Button, Emergency Button"],
            ["Flowmeter", "2.5 Inch Itron Flowmeter"],
            ["Valve", "2.5 Inch Iron Cast Butterfly Motorized Valve"],
            ["Flange", "1x Machino Male Output, 1x Machino Female Input"],
          ],
        },
      ],
      docsTitle: "Dokumentasi",
      docs: [
        {
          title: "Pelabuhan Tanjung Priok",
          desc: "Pemasangan IDasWmeter",
          img: "wm1.jpg",
        },
        {
          title: "Pelabuhan Tanjung Priok",
          desc: "Pemasangan IDasWmeter",
          img: "wm2.jpg",
        },
      ],
    },
  };

  const t = text[language] || text.en;

  const handleDownloadPDF = () => {
    const img = new Image();
    img.src = brochureImg;
    img.onload = () => {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pageWidth;
      const imgHeight = (img.height * imgWidth) / img.width;

      let y = 0;
      if (imgHeight < pageHeight) {
        y = (pageHeight - imgHeight) / 2;
      }

      pdf.addImage(img, "PNG", 0, y, imgWidth, imgHeight);
      pdf.save("I-DasWaterMeter-Brochure.pdf");
    };
  };

  const handleDownloadManual = async () => {
    try {
      const response = await fetch(userManualPDF); 
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "mel_usermanual_dasWmeter.pdf";

      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download PDF:", error);
    }
  };


  return (
    <div className="font-inter text-gray-900 px-4 sm:px-8 md:px-20 lg:px-40">
      <section
        className="relative flex flex-col md:flex-row-reverse items-center justify-between 
             px-4 sm:px-6 md:px-10 py-10 sm:py-14 md:py-20 
             mx-4 sm:mx-6 md:mx-10 
             mt-20 sm:mt-14 md:mt-20 
             overflow-hidden rounded-[40px] 
             shadow-[0_25px_60px_rgba(55,140,231,0.5)]"
        style={{
          background:
            "linear-gradient(100deg, #DFF5FF 10%, #FFFFFF 40%, #2652A4 100%)",
        }}
      >
        <div className="w-full md:w-1/2 mb-6 md:mb-0 flex justify-center z-10">
          <img
            src={require("../assets/products/watermeter/daswater.png")}
            alt={t.title}
            className="w-full max-w-[700px] sm:max-w-[800px] object-contain drop-shadow-[0_20px_50px_rgba(55,140,231,0.6)] transition-transform duration-500 ease-out"
          />
        </div>
        <div className="w-full md:w-1/2 z-20 text-left text-[#1446A5] md:pr-10 sm:md:pr-20">
          <h1 className="text-2xl sm:text-3xl md:text-3xl font-extrabold mb-4 sm:mb-6 leading-snug">
            {t.title} <br />
            <span className="text-[#1446A5] drop-shadow-md">I DAS Water Meter</span>
          </h1>

          <h2 className="text-lg sm:text-xl md:text-lg opacity-100 font-medium mb-4 sm:mb-6 leading-relaxed max-w-[400px] sm:max-w-[480px]">
            {t.subtitle}
          </h2>

          <div className="flex justify gap-4">
            <button
              onClick={handleDownloadPDF}
              className="bg-[#2652A4] text-white font-medium text-sm px-3 py-2 rounded-full shadow-md hover:shadow-lg flex items-center gap-1 transition-all hover:scale-105"
            >
              {t.download}
              <FileText className="w-4 h-5" />
            </button>

            <button
              onClick={handleDownloadManual}
              className="bg-[#2652A4] text-white font-medium text-sm px-3 py-2 rounded-full shadow-md hover:shadow-lg flex items-center gap-1 transition-all hover:scale-105"
            >
              {t.manual}
              <BookAlert className="w-4 h-5" />
            </button>

          </div>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
            {t.features.map((f, i) => (
              <div key={i} className="flex flex-col items-center">
                <img
                  src={f.icon}
                  alt={f.label}
                  className="w-8 sm:w-10 md:w-12 mb- "
                />
                <p className="text-[#1446A5] text-xs sm:text-sm font-medium leading-snug">
                  {f.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 sm:px-6 md:px-10 py-8 sm:py-12 md:py-18 mt-20">
        <div className="block md:hidden mb-6">
          <h3 className="text-[#1446A5] text-2xl sm:text-3xl font-extrabold leading-loose tracking-widest">
            {t.specTitle}
          </h3>
        </div>

        <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:gap-12">
          <div className="order-2 md:order-2 md:w-1/2 flex flex-col">
            <div className="grid grid-cols-2 gap-3 sm:gap-4 items-stretch text-[12px] sm:text-[14px] md:text-base">
              {t.specs.map((spec, i) => (
                <div
                  key={i}
                  className={`bg-white rounded-lg p-3 sm:p-4 md:p-2 flex flex-col justify-between h-full ${spec.title === t.specs[t.specs.length - 1].title
                      ? "col-span-2 order-2"
                      : "order-1"
                    }`}
                >
                  <div>
                    <div className="font-semibold mb-3 text-[20px]">{spec.title}</div>

                    {Array.isArray(spec.desc) ? (
                      <ul className="mt-1 sm:mt-2 text-gray-700 space-y-1">
                        {spec.desc.map((d, idx) => (
                          <li key={idx} className="text-[20px] sm:text-sm">
                            {d}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div className="mt-1 sm:mt-2 text-gray-700 text-[20px] sm:text-sm whitespace-pre-line">
                        {spec.desc}
                      </div>
                    )}
                  </div>
                  <div className="mt-2 border-b border-gray-300" />
                </div>
              ))}
            </div>
          </div>

          <div className="order-2 md:order-1 md:w-1/2 flex flex-col justify-between mt-10 md:mt-0">
            <div>
              <h3 className="text-[#1446A5] hidden md:block text-3xl sm:text-4xl md:text-6xl font-extrabold leading-loose tracking-widest mt-14 sm:mt-14 md:mt-32 ml-28">
                {t.specTitle}
              </h3>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
export default ProductWater;
